var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLogoaudiometria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.1,
    height: 68.1,
    viewBox: "0 0 68.1 68.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_714",
    "data-name": "Trazado 714",
    d: "M16.066,32.507a1.521,1.521,0,0,1,1.5,1.233H14.51a1.608,1.608,0,0,1,1.556-1.233m0-2.95a5.138,5.138,0,0,0-5.123,5.391,5.185,5.185,0,0,0,5.391,5.337A5.254,5.254,0,0,0,19.9,39a1.481,1.481,0,0,0-.966-2.575,1.479,1.479,0,0,0-.912.295,2.762,2.762,0,0,1-1.663.564,1.771,1.771,0,0,1-1.77-1.073h4.8a1.628,1.628,0,0,0,1.663-1.69,4.885,4.885,0,0,0-4.989-4.989ZM3.514,23.736a2.057,2.057,0,0,1,2.052-2.2,2.142,2.142,0,0,1,2.106,2.226A2.051,2.051,0,0,1,5.605,25.99a2.119,2.119,0,0,1-2.092-2.253m2.065-2.2h0M0,23.79a5.368,5.368,0,0,0,5.552,5.337,5.435,5.435,0,0,0,5.579-5.391A5.368,5.368,0,0,0,5.579,18.4,5.418,5.418,0,0,0,0,23.79m15.4-6.3v7.027a1.746,1.746,0,0,0,1.77,1.744,1.723,1.723,0,0,0,1.743-1.744V17.487a1.74,1.74,0,0,0-1.743-1.743,1.763,1.763,0,0,0-1.77,1.743M27.3,20.733c0-.778.912-.912,1.475-.912a3.968,3.968,0,0,1,1.314.215v.214c0,.751-.7,1.261-1.716,1.261-.322,0-1.073-.081-1.073-.778m-1.663-6.652A1.507,1.507,0,0,0,26.178,17a.923.923,0,0,0,.509-.107,5.952,5.952,0,0,1,1.744-.241c1.18,0,1.5.536,1.609.939a7.1,7.1,0,0,0-1.877-.242c-2.656,0-4.238,1.288-4.238,3.487A3.356,3.356,0,0,0,27.6,24.166a4.143,4.143,0,0,0,2.683-.885,1.675,1.675,0,0,0,1.5.8A1.723,1.723,0,0,0,33.5,22.4V18.051a4.522,4.522,0,0,0-1.153-3.326h-.027a4.765,4.765,0,0,0-3.487-1.18,8.479,8.479,0,0,0-3.192.537M15.234,12.954a1.741,1.741,0,0,0,1.932,1.717,1.746,1.746,0,0,0,1.9-1.717,1.692,1.692,0,0,0-1.9-1.663,1.747,1.747,0,0,0-1.932,1.663m-7.215-2.36h0M12.177,0a1.74,1.74,0,0,0-1.743,1.743V5.82c0,.7-.215,1.529-1.287,1.529-.295,0-1.234,0-1.234-1.529V1.743a1.743,1.743,0,0,0-3.487,0V6.652c0,2.435,1.388,3.936,3.606,3.943a3.484,3.484,0,0,0,2.563-1.073,1.763,1.763,0,0,0,1.582.993A1.74,1.74,0,0,0,13.92,8.77V1.743A1.74,1.74,0,0,0,12.177,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.179,
    y1: 0.885,
    x2: 0.187,
    y2: 0.885,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#3bf7d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#2deddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#09d3f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ceff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1371",
    "data-name": "Grupo 1371",
    transform: "translate(-4427.595 -5723.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(4427.595 5723.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.1,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.1,
    rx: 13.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1004",
    "data-name": "Grupo 1004",
    transform: "translate(4444.895 5737.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_986",
    "data-name": "Grupo 986",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1748",
    "data-name": "Rect\\xE1ngulo 1748",
    width: 52.174,
    height: 52.174,
    transform: "translate(-20.143 20.143) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoaudiometria);
export default __webpack_public_path__ + "static/media/ic_logoaudiometria.cfcaa56894802c6823323f5e4756c6de.svg";
export { ForwardRef as ReactComponent };